import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { CommonService } from "src/app/shared/services/common-service";
import { AppConfigService } from "src/app/app-config.service";
import { Observable } from 'rxjs';
import { catchError } from "rxjs/operators";
import { SuspicionRequest } from '../../requests/medical-record/suspicion.request';
import { ListSuspicionResponse } from "../../responses/medical-record/list-suspicion-response";
import { SuspicionResponse } from "../../responses/medical-record/suspicion-response";
import { ReturnStruct } from "src/app/shared/structs/return.struct";
import { ApiEnum } from "src/app/shared/enum/api.enum";
import { EndpointBuilderService } from "../../endpint-builder.service";


@Injectable({
    providedIn: 'root'
  })
  export class SuspicionService extends CommonService{
  
    constructor(private router: Router, private httpClient: HttpClient, configService: AppConfigService, private endpointBuilder: EndpointBuilderService) {
      super(configService);
    }

    public getAllSuspicion(searchText: string): Observable<ListSuspicionResponse>{
      let uri = `Suspicion`
  
      return this.httpClient.get<ListSuspicionResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiMedicalRecord) + uri, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
    }

    public getSuspicion(idSuspicion: number): Observable<SuspicionResponse>{
      let uri = `Suspicion/idSuspicion/${idSuspicion}`
  
      return this.httpClient.get<SuspicionResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiMedicalRecord) + uri, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
   }

   public createSuspicion(suspicionRequest: SuspicionRequest): Observable<ReturnStruct>{
    let uri = 'Suspicion'

    return this.httpClient.post<ReturnStruct>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiMedicalRecord) + uri, suspicionRequest, this.addHeaderToken())
    .pipe(
      catchError(this.handleError)
    )
   }

   public updateSuspicion(idSuspicion: number, suspicionRequest: SuspicionRequest): Observable<ReturnStruct>{
    let uri = `Suspicion/idSuspicion/${idSuspicion}`

    return this.httpClient.put<ReturnStruct>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiMedicalRecord) + uri, suspicionRequest, this.addHeaderToken())
    .pipe(
      catchError(this.handleError)
    )
   }
}